import axios from "axios"
import Vue from 'vue'
import { calculateDeviceTree, extractDeviceListFromTree, checkOfflineStatus, formatRssi, formatSnr, formatSpreading } from './deviceHelper.js'

const js_sleep = function (ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  })
}

const extractErrorData = function (err) {
  if ((typeof err.response !== 'undefined') && (typeof err.response.data !== 'undefined')) {
    return err.response.data
  } else {
    return err
  }
}

// --- AWAL PERBAIKAN: Tambahkan fungsi helper untuk mengambil token ---
/**
 * Mengambil token dari localStorage dan menyiapkannya untuk header Authorization.
 */
const getAuthHeaders = () => {
  const token = window.localStorage.getItem("TOKEN");
  if (token) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
}
// --- AKHIR PERBAIKAN ---

const convertPayloadToQueryString = function (payload) {
  let vresult = ''
  if (payload) {
    let vkeys = Object.keys(payload)
    vkeys.forEach((vkey, vindex) => {
      if (vindex > 0) {
        vresult += '&'
      }
      vresult += vkey + '=' + payload[vkey]
    })
  }
  return vresult
}

const devices = {
  namespaced: true,
  state: () => ({
    deviceTree: {
      loaded: false,
      dataset: [],
      selected: null,
      isLoading: false,
      filter: { status: 'all' },
    },
    history: {},
    daily: {},
    testing: {},
    singleDevice: {},
    photographList: [],
    unreadAlerts: {}, // <-- 1. State untuk menyimpan summary notifikasi
  }),
  mutations: {
    // ... (mutations yang sudah ada) ...

    // --- PERBAIKAN: Tambahkan mutasi untuk notifikasi ---
    setUnreadAlerts(state, summary) {
      // payload adalah array of objects, e.g., [{ devicecode: 'A', count: 2 }, ...]
      // Kita ubah menjadi map untuk akses cepat: { 'A': { unread_count: 2, latest_message: 'Foo' } }
      const summaryMap = summary.reduce((map, item) => {
        map[item.devicecode] = item;
        return map;
      }, {});
      Vue.set(state, 'unreadAlerts', summaryMap);
    },
    markDeviceAlertsAsRead(state, devicecode) {
      if (state.unreadAlerts[devicecode]) {
        Vue.set(state.unreadAlerts, devicecode, 0);
      }
    },
    // --- AKHIR PERBAIKAN ---

    loadDeviceTree(state, payload) {
      console.log('Load Device Tree', payload)
      let xChildren = payload.data
      let vRoot = payload
      vRoot.name = 'root'
      delete vRoot['data']
      vRoot.children = xChildren
      console.log('Root Device', vRoot)

      let searchId = null
      if (payload.searchId) {
        searchId = payload.searchId
      }
      let vresult = calculateDeviceTree(vRoot, searchId, payload?.filter?.status, payload?.filter?.sub_status)
      let xresult = vresult.result
      // if (searchId !== null && xresult.selected) {
      //   console.log('selected....', xresult.selected)
      // }
      console.log('vresult', vresult)
      console.log('xresult', xresult)
      Vue.set(state, 'deviceTree', {
        loaded: true,
        root: vRoot,
        selected: xresult.selected,
        filter: payload.filter || state.deviceTree.filter
      })
      Vue.set(state, 'any_dc_device', vresult.any_dc_device)
    },
    selectDeviceItem(state, payload) {
      Vue.set(state.deviceTree, 'selected', payload)
    },
    isLoading(state, mode) {
      Vue.set(state.deviceTree, 'isLoading', mode)
    },
    deviceHistory(state, payload) {
      let devcode = payload.devicecode
      let devdata = payload.data
      let tanggal = payload.tanggal
      let index = devcode + '#' + tanggal
      Vue.set(state.history, index, devdata)
    },
    deviceDaily(state, payload) {
      let devcode = payload.devicecode
      let devdata = payload.data
      let from = payload.from
      let to = payload.to
      let index = devcode + '#' + from + '#' + to
      Vue.set(state.daily, index, devdata)
    },
    deviceTesting(state, payload) {
      let devcode = payload.devicecode
      let devdata = payload.data
      // state.history[devcode] = devdata
      // console.log('device-history-mutation', devcode, devdata)
      Vue.set(state.testing, devcode, devdata)
    },
    singleDevice(state, payload) {
      console.log('mutation single device', payload)
      if (payload && payload.devicecode) {
        const vOffline = checkOfflineStatus(payload)
        payload.offlineStatus = vOffline.offlineStatus
        payload.dataAge = vOffline.dataAge
        payload.rssi_desc = formatRssi(payload.rssi)
        payload.snr_desc = formatSnr(payload.snr)
        payload.spreading_desc = formatSpreading(payload.spreading)
        if (payload.offlineStatus === 'offline') {
          payload.power = 0
          payload.current = 0
          payload.voltage = 0
          payload.brightness = 0
          payload.rssi_strength = 'offline'
          payload.rssi_strength_desc = 'Offline'
          payload.rssi_desc = 'Offline'
          payload.snr_desc = 'Offline'
          payload.spreading_desc = 'Offline'
        }
      }
      Vue.set(state, 'singleDevice', payload)
    },
    photographList(state, payload) {
      console.log('mutation photograph list', payload)
      Vue.set(state, 'photographList', payload)
    },
  },
  actions: {
    // --- PERBAIKAN: Tambahkan action untuk mengambil data notifikasi ---
    async fetchUnreadAlerts(context) {
      try {
        const response = await axios.get('spju/alerts/summary', { headers: getAuthHeaders() });
        if (response.data && response.data.data) {
          context.commit('setUnreadAlerts', response.data.data);
        }
      } catch (error) {
        console.error("Error fetching unread alerts summary:", error);
        // Opsional: handle error, misalnya dengan menampilkan notifikasi
      }
    },
    async markAllAlertsAsReadForDevice(context, devicecode) {
      try {
        await axios.post(`spju/alerts/read/${devicecode}`, {}, { headers: getAuthHeaders() });
        // Optimistically update local state (remove device from unread list)
        context.commit('markDeviceAlertsAsRead', devicecode);
      } catch (error) {
        console.error(`Error marking alerts read for ${devicecode}:`, error);
      }
    },
    async markAllAlertsAsReadGlobal(context) {
      try {
        await axios.post(`spju/alerts/read/all`, {}, { headers: getAuthHeaders() });
        // Optimistically clear all alerts
        context.commit('setUnreadAlerts', []);
      } catch (error) {
        console.error("Error marking all alerts read:", error);
      }
    },
    markDeviceAlertsAsRead(context, devicecode) {
      context.commit('markDeviceAlertsAsRead', devicecode);
    },

    async getAlertHistory(context, devicecode) {
      try {
        const response = await axios.get(`spju/alerts/${devicecode}`, { headers: getAuthHeaders() });
        return response.data;
      } catch (error) {
        console.error(`Error fetching alert history for ${devicecode}:`, error);
        throw error; // Re-throw the error to be caught by the calling component
      }
    },

    async markAlertsAsRead(context, devicecode) {
      try {
        await axios.post(`spju/alerts/read/${devicecode}`, {}, { headers: getAuthHeaders() });
        // Commit mutation to update local state
        context.commit('markDeviceAlertsAsRead', devicecode);
      } catch (error) {
        console.error(`Error marking alerts as read for ${devicecode}:`, error);
        // Don't re-throw, as failing to mark as read is not critical for UX
      }
    },
    // --- AKHIR PERBAIKAN ---

    async loadDeviceTree(context, payload) {
      console.log('channel Axios payload', payload)
      // PERBAIKAN: Tambahkan headers
      var data = await axios.get('spju/devicetree', { headers: getAuthHeaders() })
      let vresult = data.data
      console.log('received data', data.data)
      context.commit('loadDeviceTree', vresult)
    },
    async refreshDeviceTree(context, payload) {
      // convert payload to query string

      context.commit('isLoading', true)
      console.log('channel Axios payload', payload)
      let xUrl = 'spju/devicetree'
      let xQueryString = convertPayloadToQueryString(payload)
      if (xQueryString) {
        xUrl += '?' + xQueryString
      }
      // PERBAIKAN: Tambahkan headers
      var data = await axios.get(xUrl, { headers: getAuthHeaders() })
      let vresult = data.data
      vresult.filter = payload
      console.log('received data', data.data)
      if (typeof context.state !== 'undefined' && typeof context.state.deviceTree !== 'undefined' &&
        context.state.deviceTree.selected) {
        vresult.searchId = context.state.deviceTree.selected.id
      }
      await js_sleep(100)

      context.commit('loadDeviceTree', vresult, payload)
      context.commit('isLoading', false)
      // console.log(context, payload)
      console.log('Selected', context.state)
      // context.commit('selectDeviceItem', payload)
    },
    selectDeviceItem(context, payload) {
      context.commit('selectDeviceItem', payload)
    },
    async setRelay(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/relay/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setRelay", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setBrightness(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/brightness/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setBrightness", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setKwhRate(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/kwhrate/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setKwhRate", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async requestCurrentData(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/request/currentdata/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("requestCurrentData", context, payload) // <-- Nama log diperbaiki
        return res.data

      } catch (error) {
        return extractErrorData(error)
      }
    },
    async updateMaintenance(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/update/maintenance/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("updateMaintenance", context, payload)
        return res.data

      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setSchedule(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/schedule/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("set Schedule", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setTimeSync(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/timesync/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("set TimeSync", context, payload) // <-- Nama log diperbaiki
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setTotalisator(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/totalisator/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setTotalisator", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setSendInterval(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/sendinterval/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setSendInterval", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setCalibrationTime(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/calibration/time/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setCalibrationTime", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    // getDriverModel getDeviceConfig setOnOffThreshold
    async getDriverModel(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/request/fw_version/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("getDriverModel", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async getDeviceConfig(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/request/configuration/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("getDeviceConfig", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },
    async setOnOffThreshold(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/threshold/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setOnOffThreshold", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },

    async setDimSchedule(context, payload) {
      try {
        // PERBAIKAN: Tambahkan config headers
        const res = await axios.post(`spju/set/dimschedule/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
        console.log("setDimSchedule", context, payload)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },

    /**
     * Mengirim group control ke backend — proses berjalan di background server.
     * Frontend tidak perlu menunggu semua downlink selesai.
     * @param {Object} payload - { devicecodes: string[], action: string, params: Object }
     */
    async submitGroupControl(context, payload) {
      try {
        const res = await axios.post('spju/set/group-control', {
          devicecodes: payload.devicecodes,
          action: payload.action,
          params: payload.params || {},
        }, { headers: getAuthHeaders() })
        console.log('submitGroupControl', payload, res.data)
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },

    /**
     * Mengambil detail hasil group control dari notifikasi.
     * @param {Object} payload - { alertId: number }
     */
    async getGroupControlDetail(context, payload) {
      try {
        const res = await axios.get(`api/notifications/group-control/${payload.alertId}`, { headers: getAuthHeaders() })
        return res.data
      } catch (error) {
        return extractErrorData(error)
      }
    },


    async getDeviceHistory(context, payload) {
      console.log('channel Axios payload', payload)
      // PERBAIKAN: Tambahkan config headers
      var data = await axios.get(`spju/device/history/${payload.devicecode}?tanggal=${payload.tanggal}`, { headers: getAuthHeaders() })
      let vresult = data.data
      console.log('received data', vresult)
      let values = {
        devicecode: payload.devicecode,
        tanggal: payload.tanggal,
        data: vresult.data
      }
      context.commit('deviceHistory', values)
    },
    async getDeviceDaily(context, payload) {
      console.log('channel Axios payload', payload)
      // PERBAIKAN: Tambahkan config headers
      var data = await axios.get(`spju/device/daily/${payload.devicecode}?from=${payload.from}&to=${payload.to}`, { headers: getAuthHeaders() })
      let vresult = data.data
      console.log('received data', vresult)
      let values = {
        devicecode: payload.devicecode,
        from: payload.from,
        to: payload.to,
        data: vresult.data
      }
      context.commit('deviceDaily', values)
    },
    async updateDeviceTesting(context, payload) {
      console.log('testing....', payload)
      let values = {
        devicecode: payload.devicecode,
        data: 'testing - ' + Math.random()
      }
      context.commit('deviceTesting', values)

    },
    // async getDeviceHistory (context, payload){
    //   const res = await axios.post(`spju/set/calibration/time/${payload.devicecode}`)
    //   console.log("setCalibrationTime", context, payload)
    //   return res.data
    // },

    async getSingleDevice(context, payload) {
      console.log('channel Axios payload', payload)
      let vresult = {}
      try {
        // PERBAIKAN: Tambahkan config headers
        var data = await axios.get(`spju/singledevice/${payload.devicecode}`, { headers: getAuthHeaders() })
        console.log('get single device data', data)
        vresult = data.data.data
        if (!vresult) {
          vresult = {}
        }

      } catch (error) {
        vresult = {}
      }
      context.commit('singleDevice', vresult)

    },
    async getPhotographList(context, payload) {
      console.log('photograph list Axios payload', payload)
      let vresult = []
      try {
        // PERBAIKAN: Tambahkan config headers
        var axres = await axios.get(`spju/imagelist/${payload.devicecode}`, { headers: getAuthHeaders() })
        console.log('get single device data', axres)
        vresult = axres.data.data
        if (!vresult) {
          vresult = []
        }

      } catch (error) {
        vresult = []
      }
      context.commit('photographList', vresult)

    },
    async uploadPhoto(context, payload) {
      // PERBAIKAN: Gabungkan headers
      const authHeaders = getAuthHeaders();
      let options = payload.options || {};
      options.headers = { ...options.headers, ...authHeaders };

      let result = await axios.post(`spju/upload/${payload.devicecode}`, payload.formData, options)
      // --- AKHIR PERBAIKAN ---

      // var axres = await axios.get(`spju/imagelist/${payload.devicecode}`)
      // console.log('get single device data', axres)
      // vresult = axres.data.data
      return result

    },
    async updateDeviceLocation(context, payload) {
      // PERBAIKAN: Tambahkan config headers
      const res = await axios.post(`spju/updatelocation/${payload.devicecode}`, payload, { headers: getAuthHeaders() })
      console.log("updateDeviceLocation", context, payload) // <-- Nama log diperbaiki
      return res.data
    }

  },

  // getTodoById: (state) => (id) => {
  //   return state.todos.find(todo => todo.id === id)
  // }
  getters: {
    // --- PERBAIKAN: Tambahkan getter untuk notifikasi ---
    unreadAlerts: (state) => state.unreadAlerts,
    // --- AKHIR PERBAIKAN ---
    anyDcDevice(state) {
      // let result = getAnyDcDevice()
      // console.log('sss anyDcDevice', result)
      return state.any_dc_device
    },
    deviceTree(state) {
      return state.deviceTree.root
    },
    deviceTreeLoaded(state) {
      return state.deviceTree.loaded
    },
    deviceTreeLoading(state) {
      return state.deviceTree.isLoading
    },
    currentFilter(state) {
      return state.deviceTree.filter
    },
    deviceTreeSelected(state) {
      let selected = state.deviceTree.selected
      if (selected && Object.entries(selected).length > 0) {
        return selected
      }
      return state.deviceTree.root
    },
    deviceTreeSelectedList(state) {
      let selected = state.deviceTree.selected
      if (!(selected && Object.entries(selected).length > 0)) {
        selected = state.deviceTree.root
      }
      let vlist = extractDeviceListFromTree(selected)
      return vlist

    },
    deviceHistoryLoaded: (state) => (devcode, tanggal) => {
      let index = devcode + '#' + tanggal
      if (typeof state.history[index] !== 'undefined') {
        return true
      }
      return false
    },
    deviceHistory: (state) => (devcode, tanggal) => {
      let index = devcode + '#' + tanggal
      if (typeof state.history[index] !== 'undefined') {
        return state.history[index]
      }
      return undefined
    },
    deviceDailyLoaded: (state) => (devcode, from, to) => {
      let index = devcode + '#' + from + '#' + to
      if (typeof state.daily[index] !== 'undefined') {
        return true
      }
      return false
    },
    deviceDaily: (state) => (devcode, from, to) => {
      console.log('device-daily')
      let index = devcode + '#' + from + '#' + to
      if (typeof state.daily[index] !== 'undefined') {
        return state.daily[index]
      }
      return undefined
    },
    deviceTesting: (state) => (devcode) => {
      if (typeof state.testing[devcode] !== 'undefined') {
        return state.testing[devcode]
      }
      return undefined
    },
    singleDevice(state) {
      console.log('state', state)
      return state.singleDevice
    },
    photographList(state) {
      return state.photographList
    }


  }
}

export default devices